const cases = [
  {
    id: "central-market",
    product: "smart-toilet",
    lat: 22.2840728,
    lon: 114.1529032,
  },
];

export default cases;
